<template>
  <div class="page-not-found">
    <p class="title ma-12">Seite nicht gefunden</p>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
  props: {
    msg: String,
  },
};
</script>

<style lang="scss" scoped></style>
